export const getPathByChapter = chapter => {
  switch (chapter) {
    case 'exercise':
      return 'exercise';
    case 'anatomy':
    case 'muscular':
      return 'submuscle';
    case 'skeletal':
      return 'bones/video';
    case 'theory':
      return 'theory-video';
    default:
      return '';
  }
};
